module.exports = __webpack_public_path__ + "static/media/demo_results_2.25ce0307.png";